/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CrawledStatus = "NoAccess" | "None" | "Pending" | "Stale" | "Synced" | "VeryStale" | "%future added value";
export type TeammateHealthAvatar_calendarFocusTimeScore = {
    readonly calendarId: string | null;
    readonly busyMinutes: number | null;
    readonly focusMinutes: number | null;
    readonly totalMinutes: number | null;
    readonly crawledStatus: CrawledStatus;
    readonly " $refType": "TeammateHealthAvatar_calendarFocusTimeScore";
};
export type TeammateHealthAvatar_calendarFocusTimeScore$data = TeammateHealthAvatar_calendarFocusTimeScore;
export type TeammateHealthAvatar_calendarFocusTimeScore$key = {
    readonly " $data"?: TeammateHealthAvatar_calendarFocusTimeScore$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeammateHealthAvatar_calendarFocusTimeScore">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeammateHealthAvatar_calendarFocusTimeScore",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "calendarId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "busyMinutes",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "focusMinutes",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalMinutes",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "crawledStatus",
            "storageKey": null
        }
    ],
    "type": "CalendarFocusTimeScore",
    "abstractKey": null
} as any;
(node as any).hash = '2072bc410f50093a93f704f3aad601c9';
export default node;
